// Extracted from en.ts / de.ts so the (over-length) main translation files keep shrinking
// under the architecture-gate ratchet. `mcpConsent` is the MCP OAuth consent screen
// (docs/brief-mcp-server.md §"Tier 4"); `connectedApps` and `connectedAccounts` are spread
// back in under `account`.
export const enMcpConsent = {
	title: "Connect an AI application",
	subtitle: "Give an AI assistant access to your Signalist account.",
	intro:
		"{{clientName}} is asking to access Signalist on your behalf. It will be able to do everything you can do in Signalist — search prospects, build lists, score leads and draft outreach. It can never send a message to a real person.",
	application: "Application",
	account: "Account",
	company: "Company",
	redirect: "Redirects to",
	permissionNote:
		"The application acts as you and is limited to your permissions. You can disconnect it at any time under Account → Connected Accounts.",
	noMcpAccess:
		"MCP access is not enabled for your company. Talk to your Signalist contact before connecting an application.",
	approve: "Connect",
	deny: "Cancel",
	loginRequired: "Log in to your Signalist account to continue connecting this application.",
	logIn: "Log in",
	expired:
		"This request has expired or is no longer valid. Start the connection again from your AI application.",
	sessionExpired:
		"Your Signalist session has expired. Log in again to finish connecting this application.",
	unavailable:
		"Signalist could not load this request (error {{status}}). Please try again in a moment — if it keeps failing, contact support.",
	networkFailed:
		"Signalist could not be reached. Check your connection and reload this page — the request is still valid for a few minutes.",
	missingRequest: "This link is incomplete. Start the connection again from your AI application.",
	decisionFailed: "Something went wrong. Please try again.",
};

export const enConnectedApps = {
	title: "Connected AI applications",
	subtitle:
		"AI assistants you have connected to Signalist. They act as you, with your permissions.",
	empty:
		"No AI application is connected yet. Connect one from Claude, ChatGPT or any other MCP client.",
	connectedOn: "Connected on {{date}}",
	revoke: "Disconnect",
};

export const enConnectedAccounts = {
	connected: "Connected",
	notConnected: "Not connected",
	primaryLabel: "Primary",
	secondaryLabel: "Secondary",
	showOtherEmails_one: "Show {{count}} more email address",
	showOtherEmails_other: "Show {{count}} more email addresses",
	hideOtherEmails: "Hide additional email addresses",
	emailTitle: "Email",
	emailSubtitle: "Send and receive outreach from your own inbox.",
	emailActiveMeta: "Sending and reply tracking active.",
	emailLoggedOutMeta: "Logged out — reconnect to resume sending.",
	emailConnectedOn: "Connected on {{date}}",
	emailConnectHint: "Connect your inbox to send and receive outreach.",
	editEmailSettings: "Edit email settings",
	loggedOut: "Logged out",
	connectEmail: "Connect E-Mail",
	disconnect: "Disconnect",
	linkedinTitle: "LinkedIn",
	linkedinSubtitle: "Connect your account, keep connections in sync, and enrich who you know.",
	connectionSubhead: "Connection",
	loginWithLinkedin: "Login with LinkedIn",
	editLinkedinSettings: "Edit LinkedIn settings",
	reconnect: "Reconnect",
	connectLinkedin: "Connect to LinkedIn",
	noLinkedinPermission: "You do not have the permissions to connect to LinkedIn.",
	syncingSubhead: "Connection syncing",
	autoUpdateLabel: "Auto-update my LinkedIn connections",
	autoUpdateDesc:
		"When on, Signalist re-checks your connections on a schedule and marks matching leads as connected across your lists.",
	autoUpdateWindow: "Check for updates",
	syncHelp:
		"Run a one-time sync on demand, or upload your full connections export — handy when you have a large network and a scheduled sync can't reach your oldest connections. Either one backfills your full history and leaves auto-update as it is.",
	syncHelpAutoOn: "Auto-update then keeps it current on the schedule above.",
	syncHelpAutoOff:
		"While auto-update is off, your network is only updated when you sync or upload again.",
	syncNow: "Sync now",
	intervalDaily: "Daily",
	intervalWeekly: "Weekly",
	intervalMonthly: "Monthly",
	nonSendingSubtitle:
		"Sending access is managed by your admin, so connecting accounts is disabled for your role.",
	nonSendingUploadHint:
		"You can still keep your connections current by uploading your LinkedIn connections export. Automatic syncing needs sending access, which only your admin can grant.",
	uploadConnections: "Upload Connections.csv",
	autoWithdrawSubhead: "Auto-withdraw",
};
